import "./editor.css"

import Editor from "./Editor"

export default Editor
